module.exports = __webpack_public_path__ + "static/media/device-mockup.9e93553a.png";